var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCsvIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3346 10.6604V13.3338H10.668V10.6604H13.3346ZM13.3346 6.66309V9.32709H10.668V6.66309H13.3346ZM9.33464 6.66309H6.66797V9.32709H9.33464V6.66309ZM9.33464 10.6604H6.66797V13.3338H9.33464V10.6604Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.33203 2C1.33203 1.46957 1.54274 0.960859 1.91782 0.585786C2.29289 0.210714 2.8016 0 3.33203 0L14.2747 0L18.6654 4.39067V18C18.6654 18.5304 18.4547 19.0391 18.0796 19.4142C17.7045 19.7893 17.1958 20 16.6654 20H3.33203C2.8016 20 2.29289 19.7893 1.91782 19.4142C1.54274 19.0391 1.33203 18.5304 1.33203 18V2ZM14.6654 5.32933H5.33203V14.6667H14.6654V5.32933Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCsvIcon);
export default __webpack_public_path__ + "static/media/csvIcon.927799e97e9e7fb19d4ac8df97a05251.svg";
export { ForwardRef as ReactComponent };